export const getPermissionFlag = (permissions = []) => {
    return permissions && permissions.reduce((acc, item) => {
    return acc + Number(item);
}, 0)}